<template>
    <div v-if="isOpen" :class="['c-popup show-popup', placement]">
        <div id="c-popup__form" class="c-popup__form">
            <div @click="handleCloseButtonClick" class="c-popup__close">
                <img
                    src="https://dyflexis.com/wp-content/themes/ww-simple-devs-theme/images/icons/close.svg" alt=""/>
            </div>
            <div class="c-popup__banner" :style="'background-image: url('+ image +');'"></div>
            <div class="c-popup__content">
                <span class="c-popup__content__title">{{ title }}</span>
                <p v-if="description.length > 0" v-html="description" />

                <div class="c-popup__input">
                    <a :target="button.target" :href="button.url">
                        <button class="c-popup__input__button">
                            {{ button.title }}
                        </button>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        isOpen: false,
        title: null,
        description: null,
        image: null,
        button: null,
        placement: 'bottom-left',
    }),
    methods: {
        handleCloseButtonClick() {
            this.isOpen = false;
        }
    },
    created() {
        const popup = this.$page.props.popup;
        const uniqueKey = this.$page.props.uniqueLoginSessionKey;

        /*
        * Do nothing if there somehow is no uniqueKey or if the popup is
        * disabled or not present in the data some other way
        * */
        if (uniqueKey == null || popup == null) {
            return;
        }

        this.title = popup.title;
        this.description = popup.description;
        this.image = popup.image;
        this.button = popup.button;
        this.placement = popup.placement;

        /*
        * If the popup has already been opened in this login session than
        * do nothing
        * */
        if (localStorage.getItem(uniqueKey + '_popup_opened')) {
            return;
        }

        /*
        * The popup has not been opened in this login session so we open it
        * and set the localstorage item so that we don't open it again
        * on the next reload or page switch
        * */
        setTimeout(() => {
            this.isOpen = true;
            localStorage.setItem(uniqueKey + '_popup_opened', true);
        }, 30000);
    }
}
</script>
